import axios from "axios";

const BASE_API_URL = "/api/user";

class UserService {
  //取得個人資訊
  getPersonalInfo() {
    return axios.post(BASE_API_URL + "/personal-info", {});
  }
  //修改個人資訊
  //  action: "0" 純偵測（不寫 DB；若性別/生日/生辰有異動會回 resultCode=-1）
  //          "1" 或不帶 → 真的更新 + 若有異動一併清 hasUnlockedAspects / Aspect / 命盤 Study
  modifyPersonalInfo(
    name,
    gender,
    birthDate,
    timeMode,
    birthTimeSign,
    birthClockTime,
    birthLongitude,
    birthLatitude,
    birthPlace = "",
    action = "1",
  ) {
    return axios.post(BASE_API_URL + "/modify-info", {
      action,
      name,
      gender,
      birthDate,
      timeMode,
      birthTimeSign,
      birthClockTime,
      birthLongitude,
      birthLatitude,
      birthPlace,
    });
  }
  //取得個人專屬命盤
  getPersonalChart() {
    return axios.post(BASE_API_URL + "/personal-chart", {});
  }
  //取得個人專屬紫微命盤（B-3-2；帶 decadeIndex / year 切換大限流年）
  //  兩個參數擇一有值即可；都空 → 依當前虛歲 / 今年預設
  getZiweiPersonalChart({ decadeIndex, year } = {}) {
    const body = {};
    if (decadeIndex !== null && decadeIndex !== undefined) body.decadeIndex = decadeIndex;
    if (year !== null && year !== undefined) body.year = year;
    return axios.post(BASE_API_URL + "/personal-chart/ziwei", body);
  }
  //取得個人面向分析（陣列傳入，未解鎖傳 [0]、解鎖傳 [0,1,2,3,4,5,6]）
  getAspectsAnalytics(aspectTypes) {
    return axios.post(BASE_API_URL + "/aspects-analytics", { aspectTypes });
  }
  //取得購買紀錄（支援 skip/limit 分頁，回傳 { records, total }）
  getPurchaseRecords(skip, limit) {
    return axios.post(BASE_API_URL + "/purchase-records", { skip, limit });
  }
  //取得單筆訂單明細
  getOrderDetail(orderID) {
    return axios.post(BASE_API_URL + "/order-detail", { orderID });
  }
  //取得點數紀錄（近三個月，支援 skip/limit 分頁，回傳 { records, total }）
  getPointRecords(skip, limit) {
    return axios.post(BASE_API_URL + "/point-records", { skip, limit });
  }
  //取得我的書房列表（支援 skip/limit 分頁，回傳 { records, total }）
  getMyStudy(skip, limit) {
    return axios.post(BASE_API_URL + "/my-study", { skip, limit });
  }
  //上傳 / 更換大頭貼（multipart/form-data，field name = file）
  uploadUserPhoto(file) {
    const form = new FormData();
    form.append("file", file);
    return axios.post(BASE_API_URL + "/upload-photo", form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
}

export default new UserService();
